import React, { type ReactNode } from 'react';
import OnMount from '@atlassian/jira-common-util-op-triggers/src/on-mount';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries';
import { CoordinationClientWithFallback } from '@atlassian/jira-servicedesk-itsm-onboarding-common';
import { YOUR_WORK_TOUR_MESSAGE_ID, MODAL, SPOTLIGHTS, TEAM_NAME } from '../../common/constants';
import {
	YourWorkContainer,
	useItsmAudience,
	useYourWorkTour,
	useSetIsYourWorkTourCompleted,
} from '../../services';
import { ITSM_PROJECT_TYPE } from '../../services/itsm-audience/types';
import { SpotlightTour } from './spotlight-tour';
import { WelcomeModal } from './welcome-modal';

export const YourWorkTour = () => {
	const [{ data }, { fetchFirstProjectAttributes }] = useItsmAudience();
	const [{ currentStep }] = useYourWorkTour();
	const setIsYourWorkTourCompleted = useSetIsYourWorkTourCompleted();

	const renderCoordiationClient = (children: ReactNode) => (
		<CoordinationClientWithFallback
			messageId={YOUR_WORK_TOUR_MESSAGE_ID}
			fallback={<OnMount op={() => setIsYourWorkTourCompleted(true)} />}
		>
			{children}
		</CoordinationClientWithFallback>
	);

	return (
		<JSErrorBoundary
			id="ItsmYourWorkTour"
			packageName="jiraServicedeskItsmYourWorkTour"
			teamName={TEAM_NAME}
			fallback="flag"
			sendToPrivacyUnsafeSplunk
		>
			<OnMount op={fetchFirstProjectAttributes} />
			{data?.firstProjectAttributes && (
				<YourWorkContainer isGlobal projectType={data.firstProjectAttributes.projectType}>
					{/* @ts-expect-error - TS2345 - Argument of type 'STEP' is not assignable to parameter of type '"modal" | "spotlights"'. */}
					{[MODAL, SPOTLIGHTS].includes(currentStep) &&
						renderCoordiationClient(
							<>
								{currentStep === MODAL && <WelcomeModal />}
								{currentStep === SPOTLIGHTS && (
									<SpotlightTour
										withDemoProject={data.firstProjectAttributes.projectType !== ITSM_PROJECT_TYPE}
									/>
								)}
							</>,
						)}
				</YourWorkContainer>
			)}
		</JSErrorBoundary>
	);
};
